import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { InfinitePaginationProps } from '@/components/ui/custom/InfinityList';
import { Loading } from '@/components/ui/daisy';
import useInfiniteScroll from '@/data/hook/useInfiniteScroll';
import { scrollBarYClassName } from '@/utils/scrollBarClassName';
import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type CoursesTreeListProps = PropsWithChildren<
  InfinitePaginationProps & {
    isLoading: boolean;
  }
>;

export default function CoursesTreeList({
  children,
  isFetchingNextPage,
  hasNextPage,
  isLoading,
  onReachEnd,
}: CoursesTreeListProps) {
  const { endSentinelRef } = useInfiniteScroll({
    onReachEnd,
    hasNextPage,
  });

  return (
    <div
      className={twMerge('flex flex-col gap-2 max-h-full', scrollBarYClassName)}
    >
      <ConditionalRenderer condition={!isLoading}>
        {children}
      </ConditionalRenderer>
      <span ref={endSentinelRef} className="flex justify-center">
        <ConditionalRenderer condition={isFetchingNextPage}>
          <Loading size="xs" color="primary" />
        </ConditionalRenderer>
      </span>
    </div>
  );
}
